import React from 'react'
import { useTranslation } from 'react-i18next'
import { Checkbox } from '@carsys/form'

export const AvailableForPortalToggle: React.FC<{}> = () => {
  const { t } = useTranslation()

  return (
    <Checkbox
      name='AvailableForPortal'
      label={t('wholesale.show_in_portal_toggle')}
      title={t('wholesale.show_in_portal_toggle_info_title')}
    />
  )
}

export default AvailableForPortalToggle
